import { scroll_to_bottom_on_message } from "../utils/constant";

export const handleNewMessage =
  ({
    userInfo,
    selectedChat,
    setSelectedChat,
    conversations,
    setConversations,
    setMessages,
    setIsSubmittingMsg,
  }) =>
  (result) => {
    console.log(result, "handleNewMessage");
    const { data, success } = result;
    if (!success) return;

    const { message, conversation_id, conversation } = data;

    // helper: normalize conversation with receiver info
    const buildConversation = (conv) => {
      if (conv?.type === "direct" && conv?.participants?.length > 0) {
        const receiver = conv.participants.find(({ id }) => id !== userInfo.id);
        return { ...conv, ...receiver };
      }
      return conv;
    };

    // STEP 1: Handle messages for the selected chat
    const isCurrentChat =
      conversation_id === selectedChat?.conversation_id ||
      conversation?.participants?.some((p) => p.id === selectedChat?.id);

    if (isCurrentChat) {
      if (conversation) setSelectedChat(buildConversation(conversation));
      setMessages((prev) => [...prev, message]);
    }

    // STEP 2: Update or add conversation in list
    setConversations((prev) => {
      // 1. Filter out null/undefined (safety)
      const cleanPrev = prev.filter(Boolean);
      // 2. Check if conversation exists
      const exists = cleanPrev.some(
        (c) => c.conversation_id === conversation_id
      );
      if (exists) {
        return cleanPrev.map((c) =>
          c.conversation_id === conversation_id
            ? {
                ...c,
                last_message: message.content,
                last_message_id: message.message_id,
                message_created_at: message.created_at,
                sender_id: message.sender_id,
              }
            : c
        );
      } else {
        return [buildConversation(conversation), ...cleanPrev];
      }
    });
    scroll_to_bottom_on_message();
    if (message.sender.id === userInfo.id) {
      setIsSubmittingMsg(false);
    }
  };

export const handleUpdateMessage =
  ({ setMessages, setIsSubmittingMsg, userInfo, setConversations }) =>
  (result) => {
    console.log(result, "handleUpdateMessage");
    const { data, success } = result;

    if (success) {
      setMessages((old) =>
        old.map((msg) =>
          msg.message_id === data.message_id ? { ...msg, ...data } : msg
        )
      );
      setConversations((prev) =>
        prev.map((conv) => {
          if (conv.conversation_id === data.conversation_id) {
            if (conv.last_message_id === data.message_id) {
              return {
                ...conv,
                last_message: data.content,
                message_created_at: data.updated_at ?? data.created_at,
              };
            }
          }
          return conv;
        })
      );
    }
    if (data.sender.id === userInfo.id) {
      setIsSubmittingMsg(false);
    }
  };

export const handleDeleteMessage =
  ({ setMessages }) =>
  (result) => {
    console.log(result, "handleDeleteMessage");
    const { data, success } = result;
    if (success) {
      setMessages((old) =>
        old.filter((msg) => msg.message_id !== data.message_id)
      );
    }
  };
